import * as React from "react";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { TradeTransitionArrow } from "../generic/common/TradeTransitionArrow";
import { Icon } from "../generic/icon/Icon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
export var StoreItemChestPurchase = function (_a) {
    var _b = _a.item, _c = _b.balancing, packageIcon = _c.packageIcon, locaKey = _c.locaKey, randomPoolReward = _c.randomPoolReward, buildingRewardInfo = _b.buildingRewardInfo, costResourceInfo = _b.costResourceInfo, onBuyPackage = _a.onBuyPackage;
    var amount = randomPoolReward[0].amount;
    return (React.createElement("div", { className: "store-menu-detail__purchase" },
        React.createElement("div", { className: "resource-trade-info__wrapper " + IdStyles.InventoryBuyContainerCost },
            React.createElement("div", { className: "resource-trade-info__item" },
                React.createElement(ResourceIcon, { resource: costResourceInfo, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
                React.createElement("div", { className: IdStyles.TextBoldPrimary },
                    React.createElement(NumberFormat, { amount: costResourceInfo.amount }))),
            React.createElement(TradeTransitionArrow, null),
            React.createElement("div", { className: "resource-trade-info__item" },
                React.createElement(TooltipText, { id: locaKey, anchor: IdTooltipAnchor.Bottom, adjustVertical: IdTooltipAdjust.Medium },
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(Icon, { icon: packageIcon, styleId: IdStyles.IconMedium }))),
                React.createElement("div", { className: IdStyles.TextBoldPrimary },
                    React.createElement(NumberFormat, { amount: amount })))),
        React.createElement(ButtonSecondary, { onClick: function () { return onBuyPackage(amount); } },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.buy }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemChestPurchase.tsx
// module id = 2759
// module chunks = 3